import { escapeReferenceToken } from '@criteria/json-pointer';
export class Endpoint {
    constructor(path, pathItem, method, operation, service, resource) {
        this.path = path;
        this.pathItem = pathItem;
        this.method = method;
        this.operation = operation;
        this.service = service;
        this.resource = resource;
    }
    get title() {
        var _a;
        return (_a = this.operation.summary) !== null && _a !== void 0 ? _a : `${this.method.toUpperCase()} ${this.path}`;
    }
    get summary() {
        var _a;
        return (_a = this.operation.summary) !== null && _a !== void 0 ? _a : `${this.method.toUpperCase()} ${this.path}`;
    }
    get description() {
        return this.operation.description;
    }
    get slug() {
        var _a;
        const operationSlug = (_a = this.operation.operationId) !== null && _a !== void 0 ? _a : `${this.path.replaceAll('/', '-').toLowerCase()}/${this.method}`;
        return this.resource ? `${this.resource.slug}/${operationSlug}` : operationSlug;
    }
    get operationRef() {
        return `#/paths/${escapeReferenceToken(this.path)}/${this.method}`;
    }
    parameters() {
        const { parameters: pathItemParameters = [] } = this.pathItem;
        const { parameters: operationParameters = [] } = this.operation;
        return [
            ...pathItemParameters,
            ...operationParameters.filter((operationParameter) => pathItemParameters.every((pathItemParameter) => operationParameter.name !== pathItemParameter.name || operationParameter.in !== pathItemParameter.in))
        ];
    }
    requestBodyContent(preferredContentType = 'application/json') {
        var _a;
        if (((_a = this.operation.requestBody) === null || _a === void 0 ? void 0 : _a.content) === undefined) {
            return [preferredContentType, undefined];
        }
        const contentTypes = Object.keys(this.operation.requestBody.content);
        if (contentTypes.length === 0) {
            return [preferredContentType, undefined];
        }
        let contentType;
        if (contentTypes.includes(preferredContentType)) {
            contentType = preferredContentType;
        }
        else {
            contentType = contentTypes[0];
        }
        const content = this.operation.requestBody.content[contentType];
        if (content !== undefined) {
            return [contentType, content];
        }
        for (const contentType of contentTypes) {
            const content = this.operation.requestBody.content[contentType];
            if (content !== undefined) {
                return [contentType, content];
            }
        }
        return [preferredContentType, undefined];
    }
    mainSuccessResponse() {
        const successResponses = this.allResponsesWithStatusCodes().filter(([statusCode, response]) => {
            return statusCode.startsWith('2');
        });
        if (successResponses.length > 0) {
            return successResponses[0];
        }
        return undefined;
    }
    allResponsesWithStatusCodes() {
        var _a;
        const result = [];
        for (const [statusCode, response] of Object.entries((_a = this.operation.responses) !== null && _a !== void 0 ? _a : {})) {
            if (statusCode === 'default' || statusCode.match(/^[1-5](?:[0-9]{2}|XX)$/)) {
                result.push([statusCode, response]);
            }
        }
        return result;
    }
}
